import React, { useEffect, useState } from "react";
import { animate } from "motion";
import { motion, useMotionValue, useTransform } from "motion/react";
import DetectedPersonTimeline from "./DetectedPersonTimeline";
import { InformationCircleIcon } from "@heroicons/react/outline"; // Pastikan impor ini benar
import moment from "moment";
import { formatFileSize } from "Helper";
import { useDispatch, useSelector } from "react-redux";

const Detail = ({ valueCamera = {}, falseData, trueData }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState({});
  const { datavideoPath } = useSelector((state) => state.videoPath.videoPath);
  // console.log(falseData, "falseData");
  // console.log(trueData, "trueData");
  useEffect(() => {
    if (
      datavideoPath?.data?.length !== 0 &&
      datavideoPath?.data !== undefined
    ) {
      const path = datavideoPath?.data[1];
      setValue(path);
    }
  }, [dispatch, datavideoPath]);

  const count = useMotionValue(0);
  const rounded = useTransform(() => Math.round(count.get()));

  useEffect(() => {
    const controls = animate(count, trueData?.length + falseData?.length || 0, {
      duration: 0.1,
    });
    return () => controls.stop();
  }, [trueData, falseData, count]);

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
        <div className="text-mo-content-text shadow-md mt-4 md:col-span-2 p-4">
          <div className="flex items-center gap-1 mb-4">
            <InformationCircleIcon className="h-5 w-5" />
            <div className="text-sm font-semibold">Detail Informasi Video</div>
          </div>
          <div className="grid text-sm grid-cols-1 py-1 w-full">
            <div className="grid grid-cols-4 gap-2">
              <div className="font-semibold">Nama Video</div>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 0.6,
                  ease: [0.33, 1, 0.68, 1],
                }}
                className="col-span-3 font-semibold break-words"
              >
                {valueCamera?.nama_video || "N/A"}
              </motion.div>

              <div className="font-semibold">Ukuran File</div>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 0.6,
                  ease: [0.33, 1, 0.68, 1],
                }}
                className="col-span-3 font-semibold"
              >
                {formatFileSize(value?.size)}
              </motion.div>
            </div>
            <div className="grid grid-cols-4 gap-2 mt-2">
              <div className="font-semibold">Tanggal</div>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 0.6,
                  ease: [0.33, 1, 0.68, 1],
                }}
                className="col-span-3 font-semibold"
              >
                {value?.mtime
                  ? moment(value?.mtime).format("DD MMM YYYY HH:mm:ss")
                  : "N/A"}
              </motion.div>
            </div>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{
            duration: 0.6,
            ease: [0.33, 1, 0.68, 1],
          }}
          className="md:col-span-2 mt-4"
        >
          <DetectedPersonTimeline
            target={trueData?.length || 0}
            people={falseData?.length || 0}
          />
        </motion.div>
        <div className="text-mo-content-text text-right mt-4">
          <h2 className="text-sm font-semibold">Total Deteksi</h2>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: 0.6,
              ease: [0.33, 1, 0.68, 1],
            }}
            className="text-3xl md:text-8xl font-bold mt-6"
          >
            <motion.pre>{rounded}</motion.pre>
            {/* {trueData?.length + falseData?.length || 0} */}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
